<!-- Main Content -->
<main class="container mx-auto px-4 py-8">
    <!-- Hero Section -->
    <section class="bg-white rounded-xl px-6 py-10 text-center mb-10 shadow-md">
        <h1 class="text-4xl md:text-5xl font-bold text-primary mb-6">Terms Of Services</h1>
        <p class="text-lg text-lightText max-w-3xl mx-auto">
            We value your trust and are committed to protecting your privacy. This page outlines how we collect, use,
            and safeguard your information when you use our services.
        </p>
    </section>

    <!-- Quick Navigation -->
    <!-- <section class="bg-secondary rounded-xl px-6 py-8 mb-10 shadow-md">
        <h2 class="text-2xl font-bold mb-6">Quick Navigation</h2>
        <div class="flex flex-wrap gap-3">
            <button (click)="scrollToSection('terms')" class="bg-white px-4 py-2 rounded-lg text-primary hover:shadow-md transition transform hover:-translate-y-1">Terms of Service</button>
            <button (click)="scrollToSection('products')" class="bg-white px-4 py-2 rounded-lg text-primary hover:shadow-md transition transform hover:-translate-y-1">Products</button>
            <button (click)="scrollToSection('intellectual')" class="bg-white px-4 py-2 rounded-lg text-primary hover:shadow-md transition transform hover:-translate-y-1">Intellectual Property</button>
            <button (click)="scrollToSection('website-usage')" class="bg-white px-4 py-2 rounded-lg text-primary hover:shadow-md transition transform hover:-translate-y-1">Website Usage</button>
            <button (click)="scrollToSection('payment')" class="bg-white px-4 py-2 rounded-lg text-primary hover:shadow-md transition transform hover:-translate-y-1">Payment Methods</button>
            <button (click)="scrollToSection('delivery')" class="bg-white px-4 py-2 rounded-lg text-primary hover:shadow-md transition transform hover:-translate-y-1">Delivery Policy</button>
            <button (click)="scrollToSection('warranties')" class="bg-white px-4 py-2 rounded-lg text-primary hover:shadow-md transition transform hover:-translate-y-1">Warranties</button>
            <button (click)="scrollToSection('liability')" class="bg-white px-4 py-2 rounded-lg text-primary hover:shadow-md transition transform hover:-translate-y-1">Liability</button>
            <button (click)="scrollToSection('contact')" class="bg-white px-4 py-2 rounded-lg text-primary hover:shadow-md transition transform hover:-translate-y-1">Contact Us</button>
          </div>
    </section> -->

    <!-- Privacy Content -->
    <section class="bg-white rounded-xl shadow-md overflow-hidden mb-10">
        <!-- Terms of Service -->
        <div class="border-b border-borderColor" id="terms">
            <div class="flex justify-between items-center px-6 py-5 cursor-pointer hover:bg-gray-50"
                (click)="toggleAccordion($event)">
                <h3 class="text-xl font-semibold">Terms of Service</h3>
                <span class="text-2xl">+</span>
            </div>
            <div class="max-h-0 overflow-hidden px-6 transition-all duration-300 ease-in-out">
                <div class="pb-6">
                    <p class="mb-4">This document is an electronic record as per the provisions of the Information
                        Technology Act, 2000 ("IT Act") and relevant rules thereunder, as well as other applicable laws,
                        including the Consumer Protection (E-Commerce) Rules, 2020.</p>
                    <p class="mb-4">By accessing, browsing, or using www.mashhoorplus.in and/or by purchasing any
                        products offered by Mashhoor Plus Private Limited, you agree to be bound by these terms and
                        conditions.</p>
                    <p class="mb-4">Only individuals who are legally capable of entering into binding contracts under
                        the Indian Contract Act, 1872 may use or transact on this Website. If you are a minor, you may
                        access and use the Website only through a legal guardian or parent.</p>
                    <p>Mashhoor Plus reserves the right to modify these T&C at any time without prior notice. Updates
                        will be posted on the Website and become effective upon publication.</p>
                </div>
            </div>
        </div>

        <!-- Products -->
        <div class="border-b border-borderColor" id="products">
            <div class="flex justify-between items-center px-6 py-5 cursor-pointer hover:bg-gray-50"
                (click)="toggleAccordion($event)">
                <h3 class="text-xl font-semibold">Products</h3>
                <span class="text-2xl">+</span>
            </div>
            <div class="max-h-0 overflow-hidden px-6 transition-all duration-300 ease-in-out">
                <div class="pb-6">
                    <p class="mb-4"><strong>Terms of Offer:</strong> The Website offers certain products for sale
                        ("Products"), which may include promotional, sample, or trial items. All products are for
                        personal use only, unless specifically agreed otherwise.</p>
                    <p class="mb-4">We strive to provide accurate and up-to-date information regarding our products,
                        including descriptions, pricing, and visuals. However, we do not guarantee that all details are
                        accurate, complete, current, or error-free.</p>
                    <p class="mb-4"><strong>Customer Communication:</strong> By using the Website or placing an order,
                        you consent to receive communications from the Company through email, SMS, phone calls, or
                        notices posted on the Website.</p>
                    <p class="mb-2"><strong>Opt-Out Options:</strong> You can opt out of receiving communications
                        through:</p>
                    <ul class="list-disc pl-8 mb-4">
                        <li>Clicking the unsubscribe link provided in promotional emails</li>
                        <li>Emailing your request to opt out at: contact&#64;mashhoorplus.in</li>
                        <li>Sending a written request to our address</li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- Intellectual Property -->
        <div class="border-b border-borderColor" id="intellectual">
            <div class="flex justify-between items-center px-6 py-5 cursor-pointer hover:bg-gray-50"
                (click)="toggleAccordion($event)">
                <h3 class="text-xl font-semibold">Intellectual Property Rights</h3>
                <span class="text-2xl">+</span>
            </div>
            <div class="max-h-0 overflow-hidden px-6 transition-all duration-300 ease-in-out">
                <div class="pb-6">
                    <p class="mb-4">All brand names, logos, and product designs on this Website are the exclusive
                        property of Mashhoor Plus, its affiliates, or licensors, and are protected by applicable Indian
                        intellectual property laws.</p>
                    <p class="mb-4">You are not permitted to reproduce, distribute, modify, republish, resell, or
                        commercially exploit any part of the Website or its content without explicit authorization.</p>
                    <p>By making any purchase through Mashhoor Plus, you agree to bear all applicable taxes related to
                        that transaction as required by law.</p>
                </div>
            </div>
        </div>

        <!-- Website Usage -->
        <div class="border-b border-borderColor" id="website-usage">
            <div class="flex justify-between items-center px-6 py-5 cursor-pointer hover:bg-gray-50"
                (click)="toggleAccordion($event)">
                <h3 class="text-xl font-semibold">Website Usage</h3>
                <span class="text-2xl">+</span>
            </div>
            <div class="max-h-0 overflow-hidden px-6 transition-all duration-300 ease-in-out">
                <div class="pb-6">
                    <p class="mb-4"><strong>Your Account:</strong> You are allowed to create only one user account on
                        the Mashhoor Plus platform. You are fully responsible for safeguarding your account credentials
                        and for restricting access to your computer or device.</p>
                    <p class="mb-4">Accounts are non-transferable and must not be sold, traded, merged, or shared with
                        others.</p>
                    <p class="mb-4"><strong>Content & External Links:</strong> Any original content created by Mashhoor
                        Plus is protected under Indian intellectual property laws. Links to third-party websites are
                        provided for your convenience but we do not endorse or take responsibility for their content.
                    </p>
                    <p class="mb-4"><strong>Acceptable Use:</strong> You must not use our website for illegal or
                        unauthorized purposes. This includes following all applicable laws, avoiding disruptive actions,
                        and refraining from posting abusive or unlawful content.</p>
                    <p><strong>Website Security:</strong> You are strictly prohibited from attempting to breach or
                        compromise the security of the site, including accessing unauthorized data or testing system
                        vulnerabilities.</p>
                </div>
            </div>
        </div>

        <!-- Payment Methods -->
        <div class="border-b border-borderColor" id="payment">
            <div class="flex justify-between items-center px-6 py-5 cursor-pointer hover:bg-gray-50"
                (click)="toggleAccordion($event)">
                <h3 class="text-xl font-semibold">Payment Methods</h3>
                <span class="text-2xl">+</span>
            </div>
            <div class="max-h-0 overflow-hidden px-6 transition-all duration-300 ease-in-out">
                <div class="pb-6">
                    <p class="mb-2">Products available on our Website may be purchased through the following methods:
                    </p>
                    <ul class="list-disc pl-8 mb-4">
                        <li>Credit Cards, Debit Cards, Net Banking, Wallets, UPI, QR Code, PayPal, and reward points
                        </li>
                        <li>Cash on Delivery (COD)</li>
                    </ul>
                    <p class="mb-4">Note: Payments made through third-party gateways are governed by the terms of the
                        respective providers.</p>
                    <p class="mb-2"><strong>Pricing and Availability:</strong></p>
                    <ul class="list-disc pl-8">
                        <li>Prices, availability, offers, and services are subject to change without prior notice</li>
                        <li>Prices listed include GST but exclude delivery charges</li>
                        <li>A delivery fee of ₹40 will apply to orders below ₹399</li>
                        <li>Orders above ₹399 are eligible for free delivery</li>
                        <li>Prices and offers may vary between offline and online platforms</li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- Delivery Policy -->
        <div class="border-b border-borderColor" id="delivery">
            <div class="flex justify-between items-center px-6 py-5 cursor-pointer hover:bg-gray-50"
                (click)="toggleAccordion($event)">
                <h3 class="text-xl font-semibold">Delivery Policy</h3>
                <span class="text-2xl">+</span>
            </div>
            <div class="max-h-0 overflow-hidden px-6 transition-all duration-300 ease-in-out">
                <div class="pb-6">
                    <p class="mb-4">Orders with multiple products may be delivered in separate shipments with an
                        estimated delivery time of 5–7 business days. You will receive estimated timelines on the order
                        details page.</p>
                    <p class="mb-4">Delays may occur due to unforeseen circumstances, and you will be informed via email
                        in such cases. Orders may be canceled due to product unavailability or customer request if
                        delivery is delayed.</p>
                    <p><strong>Order Tracking:</strong> Tracking details will be emailed once the product is dispatched.
                        You can also track orders via the 'Your Orders' section under My Account. Tracking is available
                        24 hours post dispatch.</p>
                </div>
            </div>
        </div>

        <!-- Warranties -->
        <div class="border-b border-borderColor" id="warranties">
            <div class="flex justify-between items-center px-6 py-5 cursor-pointer hover:bg-gray-50"
                (click)="toggleAccordion($event)">
                <h3 class="text-xl font-semibold">Disclaimer of Warranties</h3>
                <span class="text-2xl">+</span>
            </div>
            <div class="max-h-0 overflow-hidden px-6 transition-all duration-300 ease-in-out">
                <div class="pb-6">
                    <p class="mb-4">Your use of the Website and Products is at your own risk. The Website and its
                        content are provided "as is" and "as available," without any warranties of any kind, express or
                        implied.</p>
                    <p class="mb-2">The Company Mashhoorplus disclaims:</p>
                    <ul class="list-disc pl-8 mb-4">
                        <li>Warranties of merchantability or fitness for a particular purpose</li>
                        <li>Responsibility for accuracy or reliability of content</li>
                        <li>Liability for damages from using the Website, including viruses or system failures</li>
                        <li>Liability for the Website's uptime or uninterrupted access</li>
                    </ul>
                    <p>Visuals of products are indicative only; actual products may vary in size, color, or appearance.
                    </p>
                </div>
            </div>
        </div>

        <!-- Liability -->
        <div id="liability">
            <div class="flex justify-between items-center px-6 py-5 cursor-pointer hover:bg-gray-50"
                (click)="toggleAccordion($event)">
                <h3 class="text-xl font-semibold">Limitation of Liability</h3>
                <span class="text-2xl">+</span>
            </div>
            <div class="max-h-0 overflow-hidden px-6 transition-all duration-300 ease-in-out">
                <div class="pb-6">
                    <p class="mb-4">To the fullest extent allowed by law, the Company shall not be liable for business
                        interruption, data loss, system issues, or any consequential damages. The maximum liability of
                        the Company shall never exceed the cost of the product purchased.</p>
                    <p class="mb-4"><strong>Indemnification:</strong> You agree to indemnify and hold harmless the
                        Company from any claims arising from breach of these Terms, use of Website or Products,
                        violation of third-party rights, or supply of misleading information.</p>
                    <p class="mb-4"><strong>Force Majeure:</strong> The Company shall not be held responsible for delays
                        or failure to perform due to events beyond its reasonable control.</p>
                    <p><strong>Entire Agreement:</strong> These Terms & Conditions constitute the complete agreement
                        between the user and the Company, superseding all prior agreements.</p>
                </div>
            </div>
        </div>
    </section>

    <!-- Contact Section -->
    <section id="contact" class="bg-white rounded-xl px-6 py-10 text-center shadow-md">
        <h2 class="text-3xl font-bold mb-4">Get in Touch</h2>
        <p class="text-lg text-lightText mb-8">For any questions, comments, or inquiries related to our products or
            website, feel free to contact us:</p>
        <div class="flex flex-col md:flex-row justify-center items-center gap-8">
            <div class="flex flex-col items-center">
                <div class="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white text-xl mb-4">
                    ✉️</div>
                <strong class="text-lg mb-1">Email</strong>
                <p>mashhoorplus&#64;gmail.com</p>
            </div>
            <div class="flex flex-col items-center">
                <div class="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white text-xl mb-4">
                    📱</div>
                <strong class="text-lg mb-1">Phone</strong>
                <p>+91 8273363610</p>
            </div>
            <div class="flex flex-col items-center">
                <div class="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-white text-xl mb-4">
                    🕒</div>
                <strong class="text-lg mb-1">Availability</strong>
                <p>Monday to Saturday</p>
                <p>9:00 AM – 6:00 PM</p>
            </div>
        </div>
    </section>
</main>